import React, { useState, useEffect } from "react";
import MainLayout from "../layouts/MainLayout";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import moment from "moment";
import SkeletonTable from "../components/Skeleton/SkeletonTable";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin } from "antd";
import EmptyData from "../components/image/EmptyData";
import { useTheme } from "@mui/material";
const TinTucPage = (props) => {
  const { tintucStore } = props;
  const [page] = useState(0);
  const [rowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const theme = useTheme();

  useEffect(() => {
    tintucStore.clear();
    (async () => {
      setLoading(true);
      try {
        await Promise.all([tintucStore.getAllNews()]);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page || rowsPerPage]);
  let newsList = toJS(tintucStore.newsList);
  moment.updateLocale("vi", {
    relativeTime: {
      s: "vừa xong ",
    },
  });
  const [hasMore, setHasMore] = useState(true);
  const fetchMoreData = async () => {
    if (newsList.length >= tintucStore.tinTucTotalCount) {
      setHasMore(false);
      return;
    }
    tintucStore.setTintucQueryParams({
      page: tintucStore.tintucQueryParams.page + 1,
      size: rowsPerPage,
    });
    try {
      await tintucStore.getAllNews();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div style={{ backgroundColor: theme.background.base, minHeight: "850px" }}>
      <div
        className="font-bold text-[28px] leading-[29px] py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}
      >
        Thông báo chung
      </div>
      <MainLayout>
        <div className="px-5 pt-20">
          {loading ? (
            <SkeletonTable />
          ) : newsList?.length > 0 ? (
            <div className="custom-table">
              <section className=" overflow-x-auto hideScrollbar work-table pb-[30px]">
                <InfiniteScroll
                  dataLength={newsList.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  style={{
                    scrollSnapStop: "always",
                  }}
                  scrollableTarget="infinityScrollableDiv"
                  loader={
                    <div
                      style={{
                        paddingTop: 20,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {newsList.length > 10 ? <Spin tip="Đang tải..." /> : ""}
                    </div>
                  }
                >
                  <div>
                    {newsList.map((row) => (
                      <div
                        onClick={() => {
                          navigate(
                            `/utility/general-notifications/view/${row.id}`
                          );
                        }}
                      >
                        <div
                          style={{
                            margin: "15px 0",
                            background: theme.background.light,
                            borderTopRightRadius: "10px",
                            borderBottomRightRadius: "10px",
                            padding: "5px",
                            boxShadow: theme.boxShadow.boxShadow1,
                            borderLeft: "5px solid #2c65ac",
                          }}
                        >
                          <div className="m-1 w-[100%]">
                            <div
                              className="tt-subject"
                              style={{
                                fontWeight: "700",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "100%",
                                whiteSpace: "nowrap",
                                marginRight: "5px",
                              }}
                            >
                              {row?.subject}
                            </div>
                          </div>
                          <div
                            style={{
                              background: "#e5f1f9",
                              borderTopRightRadius: "10px",
                              borderBottomRightRadius: "10px",
                              padding: "5px",
                              // borderLeft: '5px solid #2c65ac',
                            }}
                          >
                            <div
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "100%",
                                lineHeight: "25px",
                                WebkitLineClamp: "2",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                maxHeight: "50px",
                                padding: "4px",
                              }}
                            >
                              {row?.content ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: row?.content,
                                  }}
                                />
                              ) : (
                                <i className="text-[#9F9F9F]">Không có.</i>
                              )}
                            </div>
                            <div
                              style={{
                                color: theme.color.primary,
                                margin: "4px",
                              }}
                            >
                              {row?.created_date &&
                              moment().startOf("day") -
                                moment(row?.created_date).startOf("day") <=
                                86400000
                                ? moment(row?.created_date)
                                    .startOf("minute")
                                    .fromNow(true)
                                : moment(row?.created_date).format(
                                    "DD/MM/YYYY"
                                  )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </InfiniteScroll>
              </section>
            </div>
          ) : (
            <EmptyData />
          )}
        </div>
      </MainLayout>
    </div>
  );
};
export default inject("tintucStore")(observer(TinTucPage));
